import React from "react";
import LogoMobi2buy from "../../assets/images/logo-mobi.png";
import ImgHumaita from "../../assets/images/logo-top2you.png";
import ImgRetornar from "../../assets/images/logo-retornar.png";
import ImgCasaShopping from "../../assets/images/logo-casaShopping.png";

import ImgMetropolitano from "../../assets/images/logo_shopping_metropolitano_barra.png";
import ImgSyn from "../../assets/images/logo_instituto_syn.png";
import ImgTjerj from "../../assets/images/Logo_PJERJ.png";
import ImgBagaggio from "../../assets/images/Logo_bagaggio.svg";
import ImgGupoAguia from "../../assets/images/Logo_Grupo-Aguia_Branco.png";
import ImgKalacheAdv from "../../assets/images/Kalache.png";
import ImgCondor from "../../assets/images/logo-condro-noiz.png";
import ImgSKV from "../../assets/images/logo-skv.png";


import PartnerItem from "./item";

const Partner = () => {
  return (
    <section className="parceiros">
      <div className="parceiros-content container">
        <h2 className="subtitulo-branco">Parcerias</h2>
        <ul>
          <PartnerItem src={LogoMobi2buy} alt="Mobi2Buy" link="https://mobi2buy.com/"></PartnerItem>
          <PartnerItem src={ImgHumaita} alt="Grupo Humaitá" link="http://humaitagroup.com.br/"></PartnerItem>
          <PartnerItem src={ImgCasaShopping} alt="Casa Shopping" link="https://www.casashopping.com/"></PartnerItem>
          <PartnerItem src={ImgMetropolitano} alt="Shopping Metropolitano Barra" link="https://www.shoppingmetropolitanobarra.com.br/"></PartnerItem>
          <PartnerItem src={ImgSyn} alt="Instituto SYN" link="https://www.institutosyn.org.br/"></PartnerItem>
          <PartnerItem src={ImgTjerj} alt="Tribunal de Justiça do Rio de Janeiro" link="https://www.tjrj.jus.br/"></PartnerItem>
          <PartnerItem src={ImgGupoAguia} alt="Grupo Aguia" link="https://www.grupoaguia.com.br/"></PartnerItem>
          <PartnerItem src={ImgKalacheAdv} alt="Kalache Adv"></PartnerItem>
           <PartnerItem src={ImgCondor} link="https://www.condortravel.com/" alt="Condortravel"></PartnerItem>
           <PartnerItem src={ImgSKV} alt="SKV - Consulting Group"></PartnerItem>

        </ul>
      </div>
    </section>
  );
};

export default Partner;
